module.exports = __webpack_public_path__ + "img/338.ba690629.png";